<template>
  <div class="jin-form-base">
    <div v-if="info.form" class="jin-form-base-con">
      <el-form ref="form" :model="info.form" :rules="info.rules" class="el-form-flex">
        <div class="title jin-m">
          <h3>基本信息</h3>
        </div>
        <el-row type="flex" justify="space-between" style="width: 100%;">
          <el-col>
            <Input v-model="info.form.user_name" label="姓名" prop="user_name" />
            <Input v-model="info.form.phone_number" label="手机号码" prop="phone_number" />
          </el-col>
          <el-col class="jin-pc">
            <div class="jin-form-base-pic">
              <div
                class="image"
              >
                <img v-if="info.form.avatar" :src="info.form.avatar" alt="">
              </div>
              <Upload show-loading :size="5" class-name="jin-require" @change="handleUpload" @beforeUpload="beforeUpload" />
            </div>
          </el-col>
        </el-row>
        <Select v-model="info.form.sex" :options="info.sex" label="性别" prop="sex" />
        <Input v-model.number="info.form.age" label="年龄" prop="age" />
        <Input v-model="info.form.email" label="邮箱" prop="email" />
        <Input v-model="info.form.highest_education" label="最高学历" prop="highest_education" />
        <Input v-model="info.form.expect_salary" label="期望薪资" />
        <Input v-model="info.form.city" label="城市" />
      </el-form>

      <div class="jin-form-base-pic jin-m">
        <div class="title">
          <h3 class="jin-require">上传头像</h3>
          <p>照片1寸证件照，大小不超过5M，格式支持png、jpg、jpeg</p>
        </div>
        <van-uploader v-model="fileList" :max-count="1" :max-size="5000 * 1024" :after-read="afterRead" @oversize="onOversize" @delete="onDelete" />
      </div>
    </div>
  </div>
</template>

<script>
import { Uploader } from 'vant'
import { upload } from '@/utils/upload-oss'
import { resumeApi } from '@/api'
export default {
  components: {
    [Uploader.name]: Uploader
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      data: {},
      fileList: []
    }
  },
  watch: {
    'info.form.avatar'() {
      this.init()
    }
  },
  created() {
    this.init()
    // if (this.info.form && !this.info.form.age) this.info.form.age = undefined
  },
  methods: {
    init() {
      this.fileList = this.info.form && this.info.form.avatar ? [
        { url: this.info.form.avatar }
      ] : []
    },

    submitForm() {
      let curr = true
      this.$refs.form.validate((valid) => {
        curr = valid
      })
      return curr
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.info.form = {}
    },
    async handleUpload(url, file) {
      this.$set(this.info.form, 'avatar', url)
    },
    async afterRead(v) {
      v.status = 'uploading'
      v.message = '上传中...'
      this.data = {
        path: 'avatar/',
        suffix: v.file.name.split('.')[1]
      }
      const res = await resumeApi.upload(this.data)
      await upload(res, v.file)
      this.fileList = [
        { url: res.Url }
      ]
      this.handleUpload(res.Url)
    },
    onDelete() {
      this.$emit('delete')
    },
    beforeUpload(file) {
      const size = file.size / 1024 / 1024 < 5
      if (!size) this.Toast('文件大小不能超过 5M')
      return size
    },
    onOversize() {
      this.Toast('文件大小不能超过 5M')
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-pc {
  .jin {
    &-form {
      &-base {
        &-con {
          display: flex;
          justify-content: space-between;

          form {
            width: 100%;
          }
        }

        &-pic {
          display: flex;
          align-items: center;
          // margin-top: 22px;

          .image {
            width: 100px;
            height: 140px;
            background: #f4f5f9;
            border-radius: 2px;
            margin-right: 20px;
            overflow: hidden;
            // background-size: cover;
            // background-position: center;
            // background-repeat: no-repeat;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          /deep/ .upload {
            width: 200px;

            span {
              color: #787b8a;
              line-height: 22px;
            }

            .el-button {
              width: 200px;
              height: 42px;
              background: #dddfe3;
              border-color: #dddfe3;
              font-size: 14px;
              margin-top: 4px;
              font-weight: 500;
              color: #787b8a;
            }

            .el-upload__tip {
              margin-top: 20px;
              color: #a0a4b7;
              line-height: 17px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}

.jin-m {
  .jin {
    &-form {
      &-base {
        &-con {
          // margin-top: 43px;

          .el-form {
            padding: 20px 0;

            &-item {
              margin-bottom: 16px;
            }
          }

          .title {
            width: 260px;

            p {
              font-size: 11px;
              color: #a0a4b7;
              line-height: 18px;
            }
          }

          display: flex;
          flex-direction: column-reverse;
        }

        &-pic {
          padding: 13px 0 20px;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #e8e8ea;

          /deep/ .van-uploader {
            &__wrapper,
            .van-image {
              width: 72px;
              height: 72px;
            }

            &__upload {
              width: 100%;
              height: 100%;
              margin: 0;
            }
          }
        }
      }
    }
  }
}
</style>
